import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {map, Observable, tap} from "rxjs";
import {LoaderService} from "./loader.service";
import {ActionResult, ActionResultList, RaceSettings} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({providedIn: 'root'})
export class RaceSettingsService {
  constructor(private http: HttpClient, private loaderService: LoaderService, private environmentService:EnvironmentService) {
  }

  fetchRaceSettings(raceId: number | undefined, hideLoading?: boolean): Observable<RaceSettings | null> {
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.post<ActionResult<RaceSettings>>(this.environmentService.getApiUrl() +
      "/api/racesettings/getbyraceid", raceId)
      .pipe(
        tap(() => {
          if (!hideLoading) {
            this.loaderService.dismissLoading()
          }
        }),
        map((value: ActionResult<RaceSettings>) => {
          if (value && value.result) {
            return value.result;
          } else {
            return null;
          }
        })
      );
  }

  fetchRaceSettingsByEventId(eventId: number | undefined, hideLoading?: boolean): Observable<RaceSettings[] | null> {
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.post<ActionResultList<RaceSettings[], number>>(this.environmentService.getApiUrl() +
      "/api/racesettings/getbyeventid", eventId)
      .pipe(
        tap(() => {
          if (!hideLoading) {
            this.loaderService.dismissLoading()
          }
        }),
        map((value: ActionResultList<RaceSettings[], number>) => {
          if (value && value.result) {
            return value.result;
          } else {
            return [];
          }
        })
      );
  }

  updateRaceSettings(settings: RaceSettings, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/racesettings/update", settings)
      .subscribe((actionResult: ActionResult<boolean>) => {
        if (actionResult.resultCode !== -1) {
          onSuccess();
        } else {
          onError();
        }
      });
  }
}
